import React from "react";
import { Link } from "react-router-dom";

import "./Gallery.css";

import { Gleamin } from "../galleryImages";
import SingleGalleryG from "./singleGalleryG/SingleGalleryG";

function GleaminGallery() {
  return (
    <div className="gallery">
      {Gleamin.map((image) => (
        <div className="item" key={image._id}>
          <SingleGalleryG image={image} />
        </div>
      ))}

      <div className="pagination">
        <Link to="/homebound-fieldwork">
          <div className="pageLeft">&#60; Homebound Fieldwork</div>
        </Link>

        {/*
<Link to="/past-the-junction">
  <div className="pageRight">Past The Junction &#62;</div>
</Link>
*/}
      </div>
    </div>
  );
}

export default GleaminGallery;
